import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
  
} from "react-router-dom";


const router=createBrowserRouter([
  {
    path:"/",
    element:<App/>
  },
  {
    path:"/home",
    element:<App/>
  },
]);
 // eslint-disable-next-line
const root=ReactDOM.createRoot(document.getElementById("root")).render(
  
  <RouterProvider router={router} />
);
export default App;
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
